import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {
  NdcColumnInferenceRequest,
  NdcColumnInferenceResponse,
  NdcSpreadsheetImportRequest,
  NdcSpreadsheetImportResponse,
} from './constants/AntibodyNestedDataCreationSpreadsheetImportConstants';

export function inferColumnTypesForSpreadsheetImport(
  input: NdcColumnInferenceRequest
): Promise<NdcColumnInferenceResponse> {
  // TODO(BNCH-142553): Update this to catch BadRequestError if one is thrown for spreadsheet-wide errors
  return net.postJSONPromise({
    url: '/1/api/antibodies:infer-column-types-for-spreadsheet',
    data: input,
  });
}

export function nestedCreateAndRegisterFromSpreadsheetImport(
  input: NdcSpreadsheetImportRequest
): Promise<NdcSpreadsheetImportResponse> {
  // TODO(BNCH-142554): Update this to catch BadRequestError and return the validationErrors instead
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:nested-create-and-register-from-spreadsheet',
    data: input,
  });
}
